//libs
import React, { useContext, useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import useWorks from "../../hooks/useWorks";
import useUsers from "../../hooks/useUsers";
import useJournals from "../../hooks/useJournals";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";
import { CartContext } from "../../contexts/CartContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import ContentLoader from "react-content-loader";
import Switch from "react-switch";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as Tooltip from "react-tooltip";
import { Form, Formik } from "formik";
import Rating from "@mui/material/Rating";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const assetsUri = import.meta.env.ASSETS_URI;

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import ProgramSketchUpImage from "../../assets/icons/programs/sketchUp.png";
import Program3dsMaxImage from "../../assets/icons/programs/3dsMax.png";
import ProgramRevitImage from "../../assets/icons/programs/autodeskRevit.png";
import ProgramCinema4DImage from "../../assets/icons/programs/cinema4d.png";
import ProgramUnrealImage from "../../assets/icons/programs/unreal.png";
import ProgramAutocadImage from "../../assets/icons/programs/autocad.png";
import ProgramArchicadImage from "../../assets/icons/programs/archicad.png";
import ProgramRhinoImage from "../../assets/icons/programs/rhino.png";

import ProgramVRayImage from "../../assets/icons/programs/vray.png";
import ProgramCoronaImage from "../../assets/icons/programs/corona.png";
import ProgramD5RenderImage from "../../assets/icons/programs/d5render.png";
import ProgramEnscapeImage from "../../assets/icons/programs/enscape.jpg";
import ProgramLumionImage from "../../assets/icons/programs/lumion.png";

//component
import { ReactComponent as FilesSVG } from "../../assets/workExchange/files.svg";
import { ReactComponent as ArrowRightSVG } from "../../assets/workExchange/arrow-right-circle.svg";
import { ReactComponent as ArrowLeftSVG } from "../../assets/workExchange/arrow-left-circle.svg";
import { ReactComponent as ArrowRightDisabledSVG } from "../../assets/workExchange/arrow-right-circle-disabled.svg";
import { ReactComponent as ArrowLeftDisabledSVG } from "../../assets/workExchange/arrow-left-circle-disabled.svg";
import { ReactComponent as LikeSVG } from "../../assets/workExchange/likes.svg";
import { ReactComponent as DownloadSvg } from "../../assets/workExchange/download.svg";
import { ReactComponent as DownloadPrimarySvg } from "../../assets/workExchange/download-primary.svg";
import { ReactComponent as ViewSVG } from "../../assets/workExchange/eye.svg";
import { ReactComponent as ShareSvg } from "../../assets/workExchange/icon-share.svg";
import { ReactComponent as EditSvg } from "../../assets/workExchange/edit.svg";
import { ReactComponent as TrashSvg } from "../../assets/workExchange/icon-trash.svg";
import { ReactComponent as MessageSvg } from "../../assets/profile/message.svg";
import TextArea from "../../components/common/TextArea";
import Button from "../../components/common/Button";
import RatingStar from "../common/Rating";

import { PAGE_STATE } from "../../constants";
import { useParams } from "react-router-dom";
import SharePopup from "./Modal/SharePopup";
import DeletePopup from "./Modal/DeletePopup";
import ImagePopup from "./Modal/ImagePopup";
import ScrollDownIndicator from "../../components/common/ScrollDownIndicator";
import PromotePopup from "./Modal/PromotePopup";
import PaymentSuccess from "../Cart/PaymentSuccess";
import Recommended from "./Recommended";
import ChatSessionContext from "../../contexts/ChatSessionContext";
import Breadcrumb from "../Breadcrumb";
import ShoppingContext from "../../contexts/ShoppingContext";

const WorkExchangeDetail = (props) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const {
    user,
    addLikes,
    removeLikes,
    isAuth,
    toggleAuthModal,
    viewProfile,
    viewCompany,
    getLang,
    designStyles,
    displayImages,
  } = useContext(AppContext);
  const {
    items: shoppingItems,
    addItem,
    setIsFetchDetail,
    isFetchDetail,
  } = useContext(CartContext);
  const { startChat } = useContext(ChatSessionContext);
  const { setShoppingFilter } = useContext(ShoppingContext);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [work, setWork] = useState(undefined);
  const [images, setImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentSlideReview, setCurrentSlideReview] = useState(0);
  const [currentBreakpoint, setCurrentBreakpoint] = useState(0);
  const [buy, setBuy] = useState(false);
  const [incart, setIncart] = useState(false);
  const [rating, setRating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLiked, setIsLiked] = useState(undefined);
  const [isCreator, setIsCreator] = useState(false);
  const [reviewDetail, setReviewDetail] = useState({
    score: 0,
    detail: "",
  });
  const [isActive, setIsActive] = useState(false);
  const [status, setStatus] = useState(isActive);
  const [toggleSharePopup, setToggleSharePopup] = useState(false);
  const [toggleDeletePopup, setToggleDeletePopup] = useState(false);
  const [toggleImagePopup, setToggleImagePopup] = useState(false);
  const [togglePromotePopup, setTogglePromotePopup] = useState(false);
  const [imagePopup, setImagePopup] = useState(false);
  const [isAddItems, setIsAddItems] = useState(false);
  const [sliderPerView, setSliderPerView] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [myReview, setMyReview] = useState([]);
  const [isSubmitReview, setSubmitReview] = useState(false);
  const [isChangeTextSubmitReview, setIsChangeTextSubmitReview] =
    useState(false);
  const [toggleSuccessModal, setToggleSuccessModal] = useState(false);
  const [detailSuccess, setDetailSuccess] = useState({
    transectionId: "",
    price: 0,
    cardNo: "",
    createDate: "",
  });
  const [owner, setOwner] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [designStylesType, setDesignStylesType] = useState([]);
  const [isCheckButton, setIsCheckButton] = useState(false);
  const [loadRecommended, setLoadRecommended] = useState(false);
  const [isEditReview, setIsEditReview] = useState(false);
  const [myUserData, setMyUserData] = useState([]);
  const [myCompanyData, setMyCompanyData] = useState([]);
  const [sizeFiles, setSizeFiles] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState(undefined);
  const [materials, setMaterials] = useState([]);

  const swiperRef = useRef(null);
  const swiperReviewRef = useRef(null);

  const {
    getWork,
    addWorkView,
    getWorkRating,
    patchWork,
    deleteWork,
    getFileWork,
  } = useWorks();

  const {
    deleteItemsAll,
    queryUserRatings,
    createRatings,
    patchRating,
    queryUsers,
    queryCompanies,
  } = useUsers();

  const navigate = useNavigate();

  const { queryJournals } = useJournals();

  const TranslationCommon = getLang(langComponent.common);
  const Translation = getLang(langComponent.profile);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  const PROGRAMS = {
    sketchUp: 1,
    "3dsMax": 2,
    revit: 3,
    cinema4D: 4,
    unreal: 5,
    rhino: 6,
    autocad: 7,
    archicad: 8,
  };

  const RENDERERS = {
    vray: 1,
    corona: 2,
    lumion: 3,
    enscape: 4,
    d5render: 5,
  };

  const CATEGORY = {
    "3DModels": "659a6f064573869e72eabd5d",
    MaterialsAndLighting: "659a6f1b4573869e72eabd5e",
    DrawingAndBlockCAD: "659a6f2c4573869e72eabd5f",
  };

  useEffect(() => {
    if (loadRecommended == true) {
      setLoading(false);
      setIsCheckButton(false);
    }

    _init().then(() => {
      setTimeout(() => {
        setIsCheckButton(true);
      }, 600);
    });
  }, [id, isAddItems, user?._id, isFetchDetail]);

  const _init = async () => {
    try {
      const _project = await getWork(id);

      // * Navigate to 404 if project is not found
      if (!_project) {
        navigate("/404");
        return;
      }

      const formatFileSize = (size) => {
        if (size < 1024 * 1024 * 1024)
          return `${(size / (1024 * 1024)).toFixed(2)} MB`;
        return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
      };

      const totalSize = _project.files.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.size;
      }, 0);

      setSizeFiles(formatFileSize(totalSize));

      const { data: _users } = await queryUsers(
        {
          _id: _project.company ?? _project.createdBy,
        },
        null,
        -1,
        {
          _id: 1,
          avatar: 1,
          firstname: 1,
          surname: 1,
          uri: 1,
        }
      );

      const { data: _companiesProject } = await queryCompanies(
        {
          _id: _project.company,
        },
        null,
        -1,
        {
          _id: 1,
          name: 1,
          logo: 1,
        }
      );

      // * set category work exchange
      const typeWorkExchange = _project.designType.workExchange;

      if (designStyles) {
        if (typeWorkExchange == CATEGORY["3DModels"]) {
          setCategoryList(designStyles.workExchangeModelTypes);
          setDesignStylesType(_project.designType.models);
        } else if (typeWorkExchange == CATEGORY.MaterialsAndLighting) {
          setCategoryList(designStyles.workExchangeMaterialTypes);
          setDesignStylesType(_project.designType.materials);
        } else if (typeWorkExchange == CATEGORY.DrawingAndBlockCAD) {
          setCategoryList(designStyles.workExchangeDrawingTypes);
          setDesignStylesType(_project.designType.drawings);
        } else {
          setCategoryList([]);
          setDesignStylesType([]);
        }
      }

      setKeywords(_project.keywords ?? []);

      const isOwner = _project.company
        ? _project.company === user?.company
        : _project.createdBy === user?._id;

      if (user?._id) {
        const { data: _journals } = await queryJournals({
          "details.work": _project._id,
          company: user?.company, // * Company
          createdBy: user?._id, // * User ที่ login
          active: true,
          deleted: false,
          status: 2,
        });

        const _bought = _journals.length > 0;
        setBuy(_bought);

        // * Navigate to 404 if project is deleted or inactive and user didn't buy
        if ((!_project.active || _project.deleted) && !_bought && !isOwner) {
          navigate("/404");
          return;
        }

        // * Query My Review for a Work
        const { data: myWorkRating } = await queryUserRatings({
          work: _project._id,
          ratedBy: user?.company ?? user?._id,
        });

        const { data: workRating } = await queryUserRatings({
          work: _project._id,
          ratedBy: {
            $ne: user?.company ?? user?._id,
          },
        });

        // if (myWorkRating.length == 0 || workRating.length == 0) return;

        // * Get firstname and surname
        const { data: users } = await queryUsers(
          {
            _id: {
              $in: workRating.map((s) => s.ratedBy),
            },
          },
          null,
          -1,
          {
            _id: 1,
            firstname: 1,
            surname: 1,
          }
        );

        const { data: _companies } = await queryCompanies(
          {
            _id: {
              $in: workRating.map((s) => s.ratedBy),
            },
          },
          null,
          -1,
          {
            _id: 1,
            name: 1,
          }
        );

        const { data: myUsers } = await queryUsers(
          {
            _id:
              myWorkRating.length > 0
                ? { $in: myWorkRating.map((s) => s.ratedBy) }
                : user?._id,
          },
          null,
          -1,
          {
            _id: 1,
            firstname: 1,
            surname: 1,
            uri: 1,
          }
        );

        const { data: myCompanies } = await queryCompanies(
          {
            _id:
              myWorkRating.length > 0
                ? { $in: myWorkRating.map((s) => s.ratedBy) }
                : user?.company
                ? user?.company
                : null,
          },
          null,
          -1,
          {
            _id: 1,
            name: 1,
          }
        );

        setMyUserData(myUsers);
        setMyCompanyData(myCompanies);
        setMyReview(
          myWorkRating.map((review) => {
            // Use find instead of map for users to get the matching user
            const filterUserData = myUsers.find(
              (u) => review.ratedBy === u._id
            );
            const _company = myCompanies.find(
              (company) => review.ratedBy === company._id
            );

            if (!filterUserData && !_company) return review;

            return {
              ...review,
              ratedBy: _company
                ? {
                    name: _company.name,
                  }
                : {
                    name: `${filterUserData.firstname} ${
                      filterUserData.surname ?? ""
                    }`,
                  },
            };
          })
        );

        setReviews(
          workRating.map((review) => {
            // Use find instead of map for users to get the matching user
            const filterUserData = users.find((u) => review.ratedBy === u._id);
            const _company = _companies.find(
              (company) => review.ratedBy === company._id
            );

            if (!filterUserData && !_company) return review;
            return {
              ...review,
              ratedBy: _company
                ? {
                    name: _company.name,
                  }
                : {
                    name: `${filterUserData.firstname} ${
                      filterUserData.surname ?? ""
                    }`,
                  },
            };
          })
        );

        setReviewDetail({
          detail: myWorkRating[0]?.msg,
          score: myWorkRating[0]?.rate ?? 0,
        });

        setData(_project, _users, _companiesProject);
      } else {
        const { data: workRating } = await queryUserRatings({
          work: _project._id,
          ratedBy: undefined,
        });

        // * Get firstname and surname
        const { data: users } = await queryUsers(
          {
            _id: {
              $in: workRating.map((s) => s.ratedBy),
            },
          },
          null,
          -1,
          {
            _id: 1,
            firstname: 1,
            surname: 1,
          }
        );

        const { data: _companies } = await queryCompanies(
          {
            _id: {
              $in: workRating.map((s) => s.ratedBy),
            },
          },
          null,
          -1,
          {
            _id: 1,
            name: 1,
          }
        );

        setReviews(
          workRating.map((review) => {
            // Use find instead of map for users to get the matching user
            const filterUserData = users.find((u) => review.ratedBy === u._id);
            const _company = _companies.find(
              (company) => review.ratedBy === company._id
            );

            if (!filterUserData && !_company) return review;
            return {
              ...review,
              data: filterUserData,
              ratedBy: _company
                ? {
                    name: _company.name,
                  }
                : {
                    name: `${filterUserData.firstname} ${
                      filterUserData.surname ?? ""
                    }`,
                  },
            };
          })
        );

        setData(_project, _users, _companiesProject);
      }

      setIsCreator(isOwner);

      setLoading(true);
      setPageState(PAGE_STATE.IDLE);
    } catch (error) {
      toast.error("Unable to get project");
    }
  };

  const setData = (_project, _users, companies) => {
    setWork(_project);
    setImages(_project.images || []);
    setStatus(_project.active);

    //* Map user to get id and avatar
    const _user = _users.find((u) => u._id === _project.createdBy);
    const _company = companies.find(
      (company) => _project?.company === company._id
    );

    const _owner = {
      _id: _user?._id ?? _company._id,
      avatar: _user ? _user.avatar : _company.logo,
      isCompany: _company ? true : false,
      name: _company ? _company.name : `${_user.firstname} ${_user.surname}`,
      uri: _company ? _company._id : _user.uri,
    };

    setOwner(_owner);

    setIsFetchDetail(false);

    // * Compute breadcrumb
    const {
      designType: {
        workExchange,
        workExchangeCategory,
        workExchangeSubCategory,
        workExchangeMaterials,
      },
    } = _project;

    const _category = designStyles.workExchanges
      .find((we) => we.value === workExchange)
      .categories.find((cat) => cat._id === workExchangeCategory);

    const _sub = _category.subs.find(
      (sc) => sc._id === workExchangeSubCategory
    );

    if (workExchangeMaterials && workExchangeMaterials.length > 0) {
      const _materials = workExchangeMaterials.map((m) =>
        _sub.materials.find((material) => material._id === m)
      );

      setMaterials(_materials);
    }

    // * Toggle chat if specified
    if (searchParams.get("chat") === "") {
      startChat(_owner._id, user._id, {
        work: id,
      });
    }

    setBreadcrumbs({
      config: [
        {
          path: "/",
          breadcrumb: _category.name,
          props: {
            pathname: `/art-designs/work-exchanges/${workExchange}`,
            onClick: () => {
              setShoppingFilter({
                categories: [workExchangeCategory],
              });
            },
          },
        },
        {
          path: "/work-exchanges",
          breadcrumb: _sub.name,
          props: {
            pathname: `/art-designs/work-exchanges/${workExchange}`,
            onClick: () => {
              setShoppingFilter({
                categories: [workExchangeCategory],
                subs: [workExchangeSubCategory],
              });
            },
          },
        },
        {
          path: "/work-exchanges/:id",
          breadcrumb: null,
        },
      ],
    });
  };

  const formatDate = (dateTime) => {
    const currentDate = new Date();
    const dateCreate = new Date(dateTime);

    const year = dateCreate.getUTCFullYear();
    const month = dateCreate.getUTCMonth() + 1;
    const day = dateCreate.getUTCDate();
    const hours = dateCreate.getUTCHours();

    const getTime = currentDate.getTime() - dateCreate.getTime();

    const countHours = Math.floor(getTime / (1000 * 60 * 60));
    const countMinute = Math.floor((getTime / (1000 * 60)) % 60);

    const dateTimeText = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    if (countHours < 1) {
      return `${parseInt(countMinute)} ${TranslationWorkExchange(
        "Minutes ago"
      )}`;
    } else if (countHours <= 24) {
      return `${parseInt(countHours)} ${TranslationWorkExchange("Hours ago")}`;
    } else {
      return dateTimeText;
    }
  };

  const isDisablePrev = currentSlide === 0;
  const isDisableNext =
    images.length <= 3 ? true : currentSlide + 4 === images.length;

  const reviewDisablePrev = currentSlideReview === 0;
  const reviewDisableNext =
    currentBreakpoint == "320"
      ? reviews.length == 1
        ? true
        : currentSlideReview + sliderPerView === reviews.length
      : currentBreakpoint == "768"
      ? reviews.length <= 2
        ? true
        : currentSlideReview + sliderPerView === reviews.length
      : currentBreakpoint == "1200"
      ? reviews.length <= 3
        ? true
        : currentSlideReview + sliderPerView === reviews.length
      : false;

  const handleLike = async (e) => {
    e.stopPropagation();

    await addLikes(id);
    setIsLiked(true);

    toast.success(TranslationCommon("Added to likes"));
  };

  const handleRemoveLike = async (e) => {
    e.stopPropagation();

    await removeLikes(id);
    setIsLiked(false);

    toast.info(TranslationCommon("Removed from likes"));
  };

  useEffect(() => {
    setIsLiked(user?.likes?.includes(id));
  }, [user?.likes, id]);

  const handleDownloadFile = async () => {
    try {
      const files = await getFileWork(id);

      const zip = new JSZip();

      for (const file of files) {
        const res = await fetch(file.link, { cache: "no-cache" });
        const blob = await res.blob();
        zip.file(file.name, blob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });

      let fileName = work.name
        .replace(/[^\w\s]/gi, "")
        .toLowerCase()
        .split(" ")
        .join("-");

      saveAs(zipBlob, `${fileName}.zip`);

      toast.success(TranslationWorkExchange("Download Complete!"));
    } catch (error) {
      console.error("Download error:", error);
      toast.error(TranslationWorkExchange("Download Failed!"));
    }
  };

  const onAddToCart = () => {
    // * check isAuth
    if (!isAuth) {
      toggleAuthModal(true, "signin");
      return;
    } else {
      addItem(id, 1);
      setIsAddItems(true);

      toast.success(TranslationWorkExchange("Added to cart"));
    }
  };

  const getView = () => {
    if (!views) return 0;
    if (views < 1000) return views;
    return `${(views / 1000).toFixed(1)}${TranslationWorkExchange("k")}`;
  };

  const getDownload = () => {
    if (!downloads) return 0;
    if (downloads < 1000) return downloads;
    return `${(downloads / 1000).toFixed(1)}${TranslationWorkExchange("k")}`;
  };

  useEffect(() => {
    if (shoppingItems) {
      let item = shoppingItems.find((item) => item.work == id);
      if (shoppingItems.length > 0 && item) {
        setIncart(true);
      } else {
        setIncart(false);
      }
    }
  }, [shoppingItems, isAddItems, id]);

  useEffect(() => {
    if (!id) return;

    addWorkView(id, user?._id);
    getWorkRating(id).then((_rating) => {
      setRating(_rating);
    });
  }, [id]);

  const getProgram = (program) => {
    if (program == PROGRAMS.sketchUp) {
      return <img src={ProgramSketchUpImage} />;
    } else if (program == PROGRAMS["3dsMax"]) {
      return <img src={Program3dsMaxImage} />;
    } else if (program == PROGRAMS.revit) {
      return <img src={ProgramRevitImage} />;
    } else if (program == PROGRAMS.cinema4D) {
      return <img src={ProgramCinema4DImage} />;
    } else if (program == PROGRAMS.unreal) {
      return <img src={ProgramUnrealImage} />;
    } else if (program == PROGRAMS.rhino) {
      return <img src={ProgramRhinoImage} />;
    } else if (program == PROGRAMS.autocad) {
      return <img src={ProgramAutocadImage} />;
    } else if (program == PROGRAMS.archicad) {
      return <img src={ProgramArchicadImage} />;
    }
  };

  const getRenderers = (renderer) => {
    if (renderer == RENDERERS.vray) {
      return <img src={ProgramVRayImage} />;
    } else if (renderer == RENDERERS.corona) {
      return <img src={ProgramCoronaImage} />;
    } else if (renderer == RENDERERS.lumion) {
      return <img src={ProgramLumionImage} />;
    } else if (renderer == RENDERERS.enscape) {
      return <img src={ProgramEnscapeImage} />;
    } else if (renderer == RENDERERS.d5render) {
      return <img src={ProgramD5RenderImage} />;
    }
  };

  const getRenderWorkType = (category) => {
    if (category == CATEGORY["3DModels"]) return "3D Models";
    else if (category == CATEGORY.MaterialsAndLighting)
      return "Materials and lighting";
    else if (category == CATEGORY.DrawingAndBlockCAD)
      return "Drawing and block CAD";
  };

  const handleEditWorkExchange = (_id, designType) => {
    navigate(`/new-project?edit=${_id}`);
  };

  const handleShareWorkExchange = () => {
    // document.body.style.overflow = "hidden";
    setToggleSharePopup(true);
  };

  const handlePromoteWorkExchange = () => {
    document.body.style.overflow = "hidden";
    setTogglePromotePopup(true);
  };

  const handleDeleteWorkExchange = () => {
    document.body.style.overflow = "hidden";
    setToggleDeletePopup(true);
  };

  const handleImageWorkExchange = (image) => {
    document.body.style.overflow = "hidden";
    setImagePopup(image);
    setToggleImagePopup(true);
  };

  const handleToggleStatus = (status) => {
    patchWork(id, { active: status });
    setStatus(status);
    toast.success(TranslationCommon("Update Status Complete"));
  };

  const handleShareClose = () => {
    // document.body.style.overflow = "unset";
    setToggleSharePopup(false);
  };

  const handleImageClose = () => {
    document.body.style.overflow = "unset";
    setToggleImagePopup(false);
  };

  const handleDeleteClose = async () => {
    setToggleDeletePopup(false);
  };

  const handleConfirmDelete = async () => {
    // * api delete work
    await deleteWork(id);
    setToggleDeletePopup(false);
    navigate(`/art-designs/work-exchanges`);
  };

  const handlePromoteClose = () => {
    document.body.style.overflow = "unset";
    setTogglePromotePopup(false);
  };

  const handleSuccessPaymentClose = () => {
    document.body.style.overflow = "unset";
    setToggleSuccessModal(false);
  };

  const handleSubmitReview = async (value) => {
    setSubmitReview(true);
    setIsEditReview(true);

    if (myReview.length == 0) {
      let { data: _rating } = await createRatings({
        rate: +value.score,
        msg: value.detail,
        for: work.createdBy,
        ratedBy: user.company ?? user._id,
        work: id,
      });

      setIsChangeTextSubmitReview(true);
      const filterUserData = myUserData.find((u) => _rating.ratedBy === u._id);
      const _company = myCompanyData.find(
        (company) => _rating.ratedBy === company._id
      );

      const Review = Object.assign(_rating, {
        ratedBy: _company
          ? {
              name: _company.name,
            }
          : {
              name: `${filterUserData.firstname} ${
                filterUserData.surname ?? ""
              }`,
            },
      });

      setReviewDetail({
        detail: _rating.msg,
        score: _rating.rate,
      });
      setMyReview([Review]);
    } else {
      let { data: _rating } = await patchRating(myReview[0]._id, {
        rate: value.score,
        msg: value.detail,
      });

      setReviewDetail({
        detail: _rating.msg,
        score: _rating.rate,
      });
    }

    setIsEditReview(false);
    setSubmitReview(false);
  };

  const handleValidate = (values) => {
    const { detail, score } = values;

    let errors = {};

    if (!detail) errors.detail = "Cannot leave empty";
    if (+score === 0) errors.score = "Please leave a score";

    return errors;
  };

  const removeItem = () => {
    deleteItemsAll(user._id);
  };

  const handleClickProfile = () => {
    if (owner.isCompany) {
      viewCompany(owner._id);
      return;
    }

    viewProfile(owner._id);
  };

  const handleChatClick = () => {
    if (!isAuth && !owner.isCompany) {
      toggleAuthModal(true, undefined, `/work-exchanges/${id}?chat`);
      return;
    }

    if (!isAuth && owner.isCompany) {
      toggleAuthModal(true, undefined, `/work-exchanges/${id}?chat`);
      return;
    }

    startChat(owner._id, user._id, {
      work: id,
    });
  };

  const skeletonLoader = (props) => (
    <ContentLoader viewBox="0 0 620 782" {...props} rtl>
      <rect x="0" y="0" rx={20} ry={20} width="620" height="100%" />
    </ContentLoader>
  );

  const skeletonLoaderList = (props) => (
    <ContentLoader
      width={"100%"}
      height={"100%"}
      viewBox="0 0 500 230"
      {...props}
    >
      <rect x="0" y="0" rx="10" ry="10" width="160" height="230" />
      <rect x="170" y="0" rx="10" ry="10" width="160" height="230" />
      <rect x="340" y="0" rx="10" ry="10" width="160" height="230" />
    </ContentLoader>
  );

  const renderFooter = () => {
    if (!images.length) return;

    return (
      <div className="work-exchange-view-content">
        <div className="work-exchange-view-content-header">
          <div className="work-exchange-view-content-title">
            <div className="work-exchange-view-content-title__btn-group">
              <button
                className={[
                  "work-exchange-view-content-title__btn",
                  isDisablePrev
                    ? "work-exchange-view-content-title__btn--disabled"
                    : "",
                ].join(" ")}
                onClick={() => {
                  swiperRef.current.swiper.slidePrev();
                }}
              >
                {isDisablePrev ? <ArrowLeftDisabledSVG /> : <ArrowLeftSVG />}
              </button>
              <button
                className={[
                  "work-exchange-view-content-title__btn",
                  isDisableNext
                    ? "work-exchange-view-content-title__btn--disabled"
                    : "",
                ].join(" ")}
                onClick={() => {
                  swiperRef.current.swiper.slideNext();
                }}
              >
                {isDisableNext ? <ArrowRightDisabledSVG /> : <ArrowRightSVG />}
              </button>
            </div>
          </div>
          <div className="work-exchange-view-content-group">
            {loading ? (
              <Swiper
                grabCursor={true}
                centeredSlides={false}
                slidesPerView={1}
                spaceBetween={20}
                navigation={false}
                ref={swiperRef}
                modules={[Pagination, Navigation]}
                breakpoints={{
                  425: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                }}
                onSlideChange={(swiperCore) => {
                  const { activeIndex } = swiperCore;
                  setCurrentSlide(activeIndex);
                }}
              >
                {images.map((image, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div
                        className="work-exchange-view-content-group-silder"
                        onClick={() => {
                          displayImages(
                            images.map((i) => i.path),
                            index
                          );
                        }}
                      >
                        <img
                          className="work-exchange-view-content-group-silder__image"
                          src={`${assetsUri}/${image.path}`}
                          alt={image._id}
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            ) : (
              <>{skeletonLoaderList()}</>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderRecommended = () => {
    return (
      <Recommended
        categoryId={designType.workExchange}
        workId={id}
        loading={loading}
        setLoadRecommended={setLoadRecommended}
      />
    );
  };

  const renderReview = () => {
    return (
      <div
        className={`${
          reviews.length > 0 || (buy && !isCreator)
            ? "work-exchange-view-reviews"
            : ""
        }`}
      >
        {reviews.length > 0 && (
          <>
            <div className="work-exchange-view-reviews-title">
              {TranslationWorkExchange("Customer are saying")}
            </div>
            <div className="work-exchange-view-reviews-content">
              <Swiper
                grabCursor={true}
                initialSlide={0}
                centeredSlides={false}
                spaceBetween={40}
                navigation={false}
                ref={swiperReviewRef}
                modules={[Pagination, Navigation]}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                }}
                onSlideChange={(swiperCore) => {
                  const { activeIndex, passedParams, currentBreakpoint } =
                    swiperCore;
                  setCurrentSlideReview(activeIndex);
                  setSliderPerView(
                    passedParams.breakpoints[currentBreakpoint].slidesPerView
                  );
                }}
                onSwiper={(swiper) => {
                  setCurrentBreakpoint(swiper.currentBreakpoint);
                  setCurrentSlideReview(swiper.activeIndex);
                }}
              >
                {reviews.map((review, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div className="work-exchange-view-reviews-content-detail">
                        <div className="work-exchange-view-reviews-content-detail__warp">
                          <Rating
                            value={review.rate}
                            name="read-only"
                            precision={0.5}
                            className="MuiRating-iconFilled"
                            icon={<StarRoundedIcon />}
                            emptyIcon={<StarBorderRoundedIcon />}
                            readOnly
                          />
                          <div className="work-exchange-view-reviews-content-detail__name">
                            {review.ratedBy?.name}
                          </div>
                          <div className="work-exchange-view-reviews-content-detail__update">
                            {formatDate(review.createdOn)}
                          </div>

                          {/* <div className="work-exchange-view-reviews-content-detail__title">
                            {review.name}
                          </div> */}
                          <div className="work-exchange-view-reviews-content-detail__desc">
                            {review.msg}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>

            <div className="work-exchange-view-reviews__btn-group">
              <button
                className={[
                  "work-exchange-view-reviews__btn",
                  reviewDisablePrev
                    ? "work-exchange-view-reviews__btn--disabled"
                    : "",
                ].join(" ")}
                onClick={() => {
                  swiperReviewRef.current.swiper.slidePrev();
                }}
              >
                {reviewDisableNext ? (
                  <ArrowLeftDisabledSVG />
                ) : (
                  <ArrowLeftSVG />
                )}
              </button>
              <button
                className={[
                  "work-exchange-view-reviews__btn",
                  reviewDisableNext
                    ? "work-exchange-view-reviews__btn--disabled"
                    : "",
                ].join(" ")}
                onClick={() => {
                  swiperReviewRef.current.swiper.slideNext();
                }}
              >
                {reviewDisableNext ? (
                  <ArrowRightDisabledSVG />
                ) : (
                  <ArrowRightSVG />
                )}
              </button>
            </div>
          </>
        )}

        {buy && !isCreator && (
          <div>
            {isEditReview || myReview.length == 0 ? (
              <div className="work-exchange-view-reviews-content-input">
                <Formik
                  initialValues={{
                    detail: reviewDetail.detail ?? "",
                    score: reviewDetail.score,
                  }}
                  onSubmit={handleSubmitReview}
                  validate={handleValidate}
                  enableReinitialize={true}
                  isInitialValid={false}
                >
                  {({ values, isValid, setFieldValue }) => (
                    <Form>
                      <div className="work-exchange-view-reviews-content-input-label">
                        {TranslationWorkExchange("Your Review")}
                      </div>
                      <TextArea
                        name="detail"
                        placeholder={TranslationCommon("Description")}
                      />
                      <Rating
                        className="MuiRating-iconFilled"
                        value={values.score}
                        precision={0.5}
                        defaultValue={values.score}
                        icon={<StarRoundedIcon fontSize="large" />}
                        emptyIcon={<StarBorderRoundedIcon fontSize="large" />}
                        onChange={(event, newValue) => {
                          setFieldValue("score", newValue);
                        }}
                      />
                      <div className="work-exchange-view-reviews-content-input-btn">
                        <Button
                          disabled={!isValid}
                          type="submit"
                          submitting={isSubmitReview}
                          label={
                            myReview.length > 0 ||
                            isChangeTextSubmitReview == true
                              ? TranslationWorkExchange("Update Review")
                              : TranslationWorkExchange("Submit")
                          }
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            ) : (
              <div className="work-exchange-view-reviews-content-input">
                <div className="work-exchange-view-reviews-content-input-label">
                  {TranslationWorkExchange("Your Review")}
                </div>
                <div className="work-exchange-view-reviews-content-input-my-review">
                  <div className="work-exchange-view-reviews-content-input-my-review-content">
                    <RatingStar score={reviewDetail.score} size={24} readOnly />
                    <div className="work-exchange-view-reviews-content-input-my-review-content__name">
                      {myReview[0].ratedBy?.name}
                    </div>
                    <div className="work-exchange-view-reviews-content-input-my-review-content__update">
                      {formatDate(myReview[0]?.createdOn)}
                    </div>
                    <div className="work-exchange-view-reviews-content-input-my-review-content__review">
                      {reviewDetail.detail}
                    </div>
                  </div>
                  <div
                    className="work-exchange-view-reviews-content-input-my-review-edit"
                    onClick={() => setIsEditReview(true)}
                    data-tooltip-id="tooltip-detail"
                    data-tooltip-content={Translation("Edit")}
                    data-tooltip-place="top"
                  >
                    <EditSvg width={24} />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderLike = () => {
    if (!isAuth || isCreator) return;

    return (
      <>
        {isLiked ? (
          <LikeSVG
            className="work-exchange-view-header-info__like--active"
            onClick={handleRemoveLike}
            width={24}
          />
        ) : (
          <LikeSVG
            className="work-exchange-view-header-info__like--inactive"
            onClick={handleLike}
            width={24}
          />
        )}
      </>
    );
  };

  const _getMaterials = () => {
    if (!work?.designType.workExchangeMaterials) return;

    return "";
  };

  if (!work) return;

  const {
    name,
    desc,
    price,
    downloads,
    program,
    renderer,
    views,
    discount,
    workFileTypes,
    banner,
    designType,
  } = work;

  const { average } = rating;

  return (
    <div className="work-exchange-view">
      <div
        className="work-exchange-breadcrumb"
        style={{ marginBottom: -36, marginLeft: 5, alignSelf: "flex-start" }}
      >
        {breadcrumbs && <Breadcrumb {...breadcrumbs} />}
      </div>
      <div className="work-exchange-view-header">
        <div className="work-exchange-view-header-container">
          <div className="work-exchange-view-header-info">
            {loading ? (
              <div className="work-exchange-view-header-info__rating">
                <RatingStar score={average} size={30} readOnly />
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div
                    className="work-exchange-view-header-info__views"
                    data-tooltip-id="tooltip-detail"
                    data-tooltip-content={Translation("Views")}
                  >
                    <ViewSVG width={24} /> {getView()}
                  </div>
                  <div
                    className="work-exchange-view-header-info__downloads"
                    data-tooltip-id="tooltip-detail"
                    data-tooltip-content={Translation("Downloads")}
                  >
                    <DownloadSvg width={24} /> {getDownload()}
                  </div>
                </div>
              </div>
            ) : (
              <ContentLoader width={"100%"} height={30}>
                <rect x="0" y="0" rx="3" ry="3" width="150" height="30" />
              </ContentLoader>
            )}
            {loading ? (
              <>
                <div className="work-exchange-view-header-info__avatar">
                  <img
                    src={`${assetsUri}/${owner.avatar}`}
                    onError={({ target }) => {
                      target.src = owner.avatar;
                    }}
                    onClick={handleClickProfile}
                  />
                  <div className="work-exchange-view-header-info__avatar__info">
                    <label onClick={handleClickProfile}>{owner.name}</label>
                    {!isCreator && (
                      <div
                        className="work-exchange-view-header-info__avatar__info__chat"
                        onClick={handleChatClick}
                      >
                        <MessageSvg
                          className="work-exchange-view-header-info__avatar__info__chat__icon"
                          width="22"
                          height="22"
                        />
                        <span className="work-exchange-view-header-info__avatar__info__chat__text">
                          Get in touch
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="work-exchange-view-header-info__title"
                  onClick={removeItem}
                >
                  {name}
                </div>
                {!buy && (
                  <div className="work-exchange-view-header-info__price">
                    {discount > 0 && (
                      <span className="work-exchange-view-header-info__price--discount">
                        {price.toLocaleString() ?? ""}
                      </span>
                    )}
                    <span
                      className={`${
                        discount
                          ? "work-exchange-view-header-info__price--have-discount"
                          : ""
                      }`}
                    >
                      {discount
                        ? (price - discount).toLocaleString()
                        : price == 0
                        ? TranslationWorkExchange("Free")
                        : price?.toLocaleString()}
                    </span>
                  </div>
                )}
              </>
            ) : (
              <ContentLoader width={"100%"} height={200}>
                <circle cx="30" cy="30" r="30" width="60" />
                <rect x="0" y="70" rx="3" ry="3" width="200" height="40" />
                <rect x="0" y="120" rx="3" ry="3" width="100" height="20" />
                <rect x="110" y="120" rx="3" ry="3" width="100" height="40" />
              </ContentLoader>
            )}
            {isCheckButton === true ? (
              <>
                {!isCreator ? (
                  <div className="work-exchange-view-header-info-button">
                    <button className="work-exchange-view-header-info__add-to-cart">
                      {buy ? (
                        <div
                          className="work-exchange-view-header-info__add-to-cart--active"
                          onClick={handleDownloadFile}
                        >
                          {TranslationWorkExchange("Download")} ({sizeFiles})
                        </div>
                      ) : isAuth && incart && !buy ? (
                        <div className="work-exchange-view-header-info__add-to-cart--disabled">
                          {TranslationWorkExchange("Added to cart")}
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            onAddToCart(work);
                          }}
                          className="work-exchange-view-header-info__add-to-cart--active"
                        >
                          {TranslationCommon("Add to cart")}
                        </div>
                      )}
                    </button>
                    <ShareSvg
                      className="work-exchange-view-header-info__share"
                      onClick={handleShareWorkExchange}
                      data-tooltip-id="tooltip-detail"
                      data-tooltip-content={Translation("Share")}
                      data-tooltip-place="top"
                      width={24}
                    />
                    <div className="work-exchange-view-header-info__like">
                      {renderLike()}
                    </div>
                  </div>
                ) : (
                  <div className="work-exchange-view-header-action">
                    <div className="work-exchange-view-header-action__status">
                      <div>{TranslationCommon("Status")}</div>{" "}
                      <Switch
                        checked={status}
                        onChange={(value) => {
                          handleToggleStatus(value);
                        }}
                        onColor="#013565"
                        // onHandleColor="#FFF"
                        handleDiameter={15}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={25}
                        width={48}
                        className="react-switch"
                      />
                    </div>
                    <div className="work-exchange-view-header-action__icon">
                      <EditSvg
                        onClick={() => {
                          handleEditWorkExchange(id, designType);
                        }}
                        data-tooltip-id="tooltip-detail"
                        data-tooltip-content={Translation("Edit")}
                        data-tooltip-place="top"
                        height={22}
                      />
                      <DownloadPrimarySvg
                        onClick={handleDownloadFile}
                        data-tooltip-id="tooltip-detail"
                        data-tooltip-content={TranslationCommon(
                          "Download File"
                        )}
                        data-tooltip-place="top"
                        height={18}
                      />
                      <ShareSvg
                        onClick={handleShareWorkExchange}
                        data-tooltip-id="tooltip-detail"
                        data-tooltip-content={Translation("Share")}
                        data-tooltip-place="top"
                        height={20}
                      />

                      <TrashSvg
                        className={`${
                          downloads > 0
                            ? "work-exchange-view-header-action__icon--disabeld"
                            : ""
                        }`}
                        onClick={handleDeleteWorkExchange}
                        data-tooltip-id="tooltip-detail"
                        data-tooltip-content={TranslationCommon("Delete")}
                        data-tooltip-place="top"
                        height={20}
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <ContentLoader width={"100%"} height={48}>
                <rect x="0" y="0" rx="20" ry="20" width="180" height="48" />
              </ContentLoader>
            )}
            {(program || renderer) && (
              <div className="work-exchange-view-header-info__detail">
                <label className="work-exchange-view-header-info__detail__label">
                  Created using
                </label>
                <div className="work-exchange-view-header-info__detail__value work-exchange-view-header-info__apps">
                  {getProgram(program)}
                  {getRenderers(renderer)}
                </div>
              </div>
            )}
            <div className="work-exchange-view-header-info__detail">
              <label className="work-exchange-view-header-info__detail__label">
                File Types
              </label>
              <div className="work-exchange-view-header-info__detail__value">
                {workFileTypes.join(", ")}
              </div>
            </div>
            {materials.length > 0 && (
              <div className="work-exchange-view-header-info__detail">
                <label className="work-exchange-view-header-info__detail__label">
                  Materials
                </label>
                <div className="work-exchange-view-header-info__detail__value">
                  {materials.map((m) => m.name).join(", ")}
                </div>
              </div>
            )}
            <div className="work-exchange-view-header-info__desc">
              <label>Description</label>
              <span>{desc}</span>
            </div>
            {keywords.length > 0 && (
              <div className="work-exchange-view-header-info__keywords">
                {keywords.map((kw) => (
                  <div className="work-exchange-view-header-info__keywords__tag">
                    {kw}
                  </div>
                ))}
              </div>
            )}
            {/* {loading ? (
              <div className="work-exchange-view-header-info-categories"></div>
            ) : (
              <div className="work-exchange-view-header-info-categories">
                {designStylesType &&
                  designStylesType.map((o, index) => {
                    if (index < 4) {
                      return (
                        <div className="work-exchange-view-header-info-categories__loader">
                          <ContentLoader width={100} height={27}>
                            <rect
                              x="0"
                              y="0"
                              rx="13"
                              ry="13"
                              width="100%"
                              height="100%"
                            />
                          </ContentLoader>
                        </div>
                      );
                    }
                  })}
              </div>
            )} */}
            <div className="work-exchange-view-header-scroll-down">
              <ScrollDownIndicator />
            </div>
          </div>
        </div>
        <div className="work-exchange-view-header-cover">
          {loading ? (
            <>
              {discount > 0 && (
                <div className="work-exchange-view-header-cover__badge">
                  {TranslationWorkExchange("SALE")}
                </div>
              )}
              <img
                className="work-exchange-view-header-cover__image"
                src={`${assetsUri}/${banner}`}
                onError={({ target }) => {
                  target.src = banner;
                }}
              />
            </>
          ) : (
            <>{skeletonLoader()}</>
          )}
        </div>
      </div>
      {renderFooter()}
      {renderRecommended()}
      {renderReview()}
      {toggleImagePopup && (
        <ImagePopup onClose={handleImageClose} image={imagePopup.path} />
      )}
      {toggleSharePopup && <SharePopup onClose={handleShareClose} />}
      {toggleDeletePopup && (
        <DeletePopup
          onClose={handleDeleteClose}
          handleConfirmDelete={handleConfirmDelete}
        />
      )}
      {togglePromotePopup && (
        <PromotePopup
          onClose={handlePromoteClose}
          work={work}
          setToggleSuccessModal={setToggleSuccessModal}
          setDetailSuccess={setDetailSuccess}
        />
      )}
      {toggleSuccessModal && (
        <PaymentSuccess
          onClose={handleSuccessPaymentClose}
          detailSuccess={detailSuccess}
          isDownload={false}
        />
      )}
      <Tooltip.Tooltip id="tooltip-detail" />
    </div>
  );
};

WorkExchangeDetail.propTypes = {};

export default WorkExchangeDetail;
